import { render } from "./P087.vue?vue&type=template&id=25b4593e&scoped=true"
import script from "./P087.vue?vue&type=script&lang=js"
export * from "./P087.vue?vue&type=script&lang=js"

import "./P087.vue?vue&type=style&index=0&id=25b4593e&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b4593e"]])

export default __exports__